module.exports = __webpack_public_path__ + "static/about_pic3-9c3af80c015e4b253852d0384fa1657a.png";